export class PerformanceCriteriaDTO{
    id!: number;
    name?: string;
    standard: any[] = [];
}